import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'react-bootstrap-icons'; // Bootstrap icon

const Notification = ({ variant, heading, subHeading, link, text, onClose }) => {

  const styles = {
    empty: { backgroundColor: '#FFF8DD', border: '1px solid #e1bb23ff' }, 
    pending: { backgroundColor: '#E6F0FF', border: '1px solid #99BFE6' }, 
    rejected: { backgroundColor: '#FFE6E6', border: '1px solid #FF9999' },
    accepted: { backgroundColor: '#E6FFE6', border: '1px solid #99E699' }, 
  };

  return (
    <div className="container my-4">
      <div
        className="p-3 rounded d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center"
        style={styles[variant] || styles.empty}
      >
        <div className="mb-3 mb-md-0">
          <h6 className="mb-1">{heading}</h6>
          <p className="mb-0 text-muted">{subHeading}</p>
        </div>

     
        {variant === 'empty' && link && (
          <Link to={link} className="btn btn-dark">{text}</Link>
        )}

        {variant === 'pending' && (
          <></>
        )}

        {variant === 'rejected' && link && (
          <Link to={link} className="btn btn-dark">{text}</Link>
        )}

        {variant === 'accepted' && (
          <button
            onClick={onClose}
            className="btn btn-link text-dark p-0"
            style={{ fontSize: '1.2rem' }}
          >
            <X />
          </button>
        )}
      </div>
    </div>
  );
};

export default Notification;
